var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{ 'opacity-50 cursor-not-allowed': _vm.disabled },on:{"click":_vm.handleClick}},[_c('Icon',{class:_vm.iconClass,attrs:{"icon":_vm.icon,"disabled":_vm.disabled}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }